export default "__VITE_ASSET__DcnxcOqu__"